// Shared imports
const articleUtils = require('shared/model-helpers/article')
const cssUtils = require('shared/css-utils')
const stringUtils = require('shared/string-utils')

module.exports = {
  // Vendor modules
  _: require('lodash'),
  // Global state
  user: wiggin.user,
  rollouts: wiggin.user.rollouts,
  experiments: wiggin.user.experiments,
  isDesktop: wiggin.browser.isDesktop,
  browser: wiggin.browser,
  articlePlaceholder: wiggin.articlePlaceholder,
  bookmarkletHref: wiggin.bookmarkletHref,
  // CSS Utils
  backgroundImage: cssUtils.backgroundImage,
  classSuffixer: cssUtils.classSuffixer,
  display: cssUtils.display,
  // Shared Utils
  BemEntity: require('shared/bem'),
  pluralize: stringUtils.pluralize,
  // Article model helper utils
  prettyPath: articleUtils.prettyPath,
  urlDataBody: articleUtils.urlDataBody,
  // Shared modules
  mixHelpers: require('shared/model-helpers/mix'),
  time: require('shared/date')
}
